import React, { Suspense } from 'react';
import { CssBaseline } from '@mui/material';
import Auth from './core/infrastructure/apollo/auth';
import Loading from './core/infrastructure/common/loading';
import Routes from './core/presentation/routes';
import './assets/css/scrollbar.css';
// import { NoAuthorizeClient } from './core/infrastructure/common/noAuthorize/noAuthorizeClient';
// import { selectClientName } from './common/utils';

const App = () => {
  // const client = selectClientName();
  // const [state, setState] = useState<any>();

  // useEffect(() => {
  //   fetch(`https://pbmbaplitjimxmljbupu.supabase.co/functions/v1/clients-api?name=${client}`, {
  //     headers: {
  //       'x-api-key': 'mili_qgoiRewri4nN2Y5J4bppZU6SqqJIqnfd',
  //     },
  //   })
  //     .then((res) => res.json())

  //     .then((data) => {
  //       setState(data);
  //     });
  // }, []);

  return (
    <>
      {/* {state?.data?.[0]?.blocked === true &&
      client !== 'local' &&
      client !== 'miliqa' &&
      client !== 'mili' ? (
        <NoAuthorizeClient />
      ) : ( */}
      <div className="App">
        <Suspense fallback={<Loading />}>
          <CssBaseline />
          <Auth>
            {(logged: any, isMount: any) => {
              if (isMount) {
                return <Routes isLogged={logged.state} />;
              }
              return <Loading />;
            }}
          </Auth>
        </Suspense>
      </div>
      {/* )} */}
    </>
  );
};

export default App;
